export default __webpack_public_path__ + "static/media/dcmotor.04a44d91.png";